<div class="linked-case-directive">
    <div class="linked-case" [class.linked-case--expandable]="isExpandable" (click)="getLinkedCaseDetails()"></div>
    <ng-container *ngIf="linkedCaseDetails && showLinkedCaseDetails">
        <div class="linked-case-details">
            <a class="link vo-link" [routerLink]="[relativeRoutePath, 'caseOverview', linkedCaseDetails?.CaseNumberAsHash, 'caseSummary']">
                {{linkedCaseDetails?.CaseNumber}}
            </a>
            <p class="strong vo-body-regular-14 vo-linked-case-customer-name" [innerHtml]="linkedCaseDetails?.CustomerName"></p>
            <p class="strong vo-body-regular-14">
                <span boiCategorizeCaseStatus [caseStatus]="linkedCaseDetails?.CaseStatus" [innerHtml]="linkedCaseDetails?.CaseStatus|localizeOption:referenceDataOptionLists.CaseStatus"></span>
            </p>
            <ng-container *ngIf="showCaseAllocation">
               <ng-template [ngIf]="linkedCaseDetails?.CaseOwner" [ngIfElse]="unallocated">
                    <p [innerHtml]="linkedCaseDetails.CaseOwner+', '+linkedCaseDetails?.CompanyName"></p>
                </ng-template>
                <ng-template #unallocated>
                    <p [innerHtml]="referenceDataLabels.CaseSummaryUnallocated|localizeLabel"></p>
                </ng-template>
            </ng-container>
        </div>
    </ng-container>
</div>
